module.exports = __WEBPACK_EXTERNAL_MODULE_82__;


//////////////////
// WEBPACK FOOTER
// external {"root":["Rx"],"commonjs":"rxjs/BehaviorSubject","commonjs2":"rxjs/BehaviorSubject","amd":"rxjs/BehaviorSubject"}
// module id = 82
// module chunks = 0